import React from 'react';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import { LoadingSection } from '@makemydeal/dr-shared-components';
import { Toast } from '../../../common/DataLoadingToast';
import { UPLOAD_LOGO_SUCCESS_MESSAGE, DELETE_LOGO_SUCCESS_MESSAGE, LOGO_ACCEPT_ATTRIBUTE } from './constants';
import { useDealerLogoUpload } from './useDealerLogoUpload';
import { FileCard } from './FileCard';
import styles from './DealerLogoUpload.module.css';

export const DealerLogoUpload: React.FC = () => {
    const {
        logoUrl,
        isLoading,
        inlineError,
        uploadedFileName,
        uploadedFileSize,
        imageWidth,
        imageHeight,
        isDragActive,
        fileInputRef,
        handleBrowseClick,
        handleDragOver,
        handleDragEnter,
        handleDragLeave,
        handleDrop,
        handleFileChange,
        handleDelete,
        isUploadLoading,
        isUploadLoaded,
        isUploadError,
        isDeleteLoading,
        isDeleteLoaded,
        isDeleteError
    } = useDealerLogoUpload();

    return (
        <Box data-testid="dealer-logo-upload" className={styles.wrapper}>
            <LoadingSection loading={isLoading} testId="dealer-logo-upload-loading" />

            <Typography variant="h6" tag="h3" data-testid="logo-section-heading">
                Logo File
            </Typography>

            <Toast
                isLoading={isUploadLoading}
                isLoaded={isUploadLoaded}
                isError={isUploadError}
                getMessage={(type) => (type === 'error' ? inlineError : UPLOAD_LOGO_SUCCESS_MESSAGE)}
            />
            <Toast
                isLoading={isDeleteLoading}
                isLoaded={isDeleteLoaded}
                isError={isDeleteError}
                getMessage={(type) => (type === 'error' ? inlineError : DELETE_LOGO_SUCCESS_MESSAGE)}
            />

            <FileCard
                logoUrl={logoUrl}
                isLoading={isLoading}
                uploadedFileName={uploadedFileName}
                uploadedFileSize={uploadedFileSize}
                imageWidth={imageWidth}
                imageHeight={imageHeight}
                isDragActive={isDragActive}
                onBrowseClick={handleBrowseClick}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onDelete={handleDelete}
            />

            <input
                ref={fileInputRef}
                type="file"
                accept={LOGO_ACCEPT_ATTRIBUTE}
                data-testid="logo-file-input"
                className={styles.hiddenInput}
                onChange={handleFileChange}
            />

            <Typography variant="body-xs" tag="p" color="base.color.gray.600" data-testid="logo-requirements-text">
                Requirements: PNG, JPG, or SVG · Max 5MB · 150 × 52 px
            </Typography>
        </Box>
    );
};

export default DealerLogoUpload;
